"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLIENT_NONPAY_POLICY_LOSS_REASONS = exports.CUSTOMER_COMPLIANCE_POLICY_LOSS_REASONS = exports.NF_UNABLE_TO_PLACE_RENEWAL_POLICY_LOSS_REASONS = exports.CONSOLIDATED_TO_PACKAGE_POLICY_LOSS_REASONS = exports.CANCEL_REWRITE_POLICY_LOSS_REASONS = exports.PRODUCER_LEFT_NEWFRONT_POLICY_LOSS_REASONS = exports.endPolicyOptions = exports.CUSTOMER_UNRESPONSIVE_POLICY_LOSS_REASONS = exports.CLIENT_PREFERENCE_POLICY_LOSS_REASONS = exports.NO_LONGER_NEED_INSURANCE_POLICY_LOSS_REASONS = exports.lostToBor = exports.newfrontNonrenew = exports.customerNonrenew = exports.customerCancel = exports.carrierCancel = exports.Steps = exports.PrimaryReason = void 0;
var PrimaryReason;
(function (PrimaryReason) {
    PrimaryReason["CUSTOMER_CANCEL"] = "Customer requested to cancel policy";
    // deprecated - keeping this to display on legacy policies cancelled with this reason
    PrimaryReason["CARRIER_NONRENEW"] = "Policy not renewing due to carrier";
    PrimaryReason["CUSTOMER_NONRENEW"] = "Policy not renewing due to customer request";
    PrimaryReason["NEWFRONT_NONRENEW"] = "Policy not renewing due to Newfront decision";
    PrimaryReason["LOST_TO_BOR"] = "Policy lost to BOR";
    PrimaryReason["CARRIER_CANCEL"] = "Carrier cancelled policy";
})(PrimaryReason = exports.PrimaryReason || (exports.PrimaryReason = {}));
var Steps;
(function (Steps) {
    Steps["PRIMARY_REASON_STEP"] = "0";
    Steps["CANCELLATION_SECONDARY_REASON_STEP"] = "1";
    Steps["SECONDARY_REASON_STEP"] = "2";
    Steps["CANCELLATION_POLICY_CHANGE_STEP"] = "2B";
    Steps["COMPLETE"] = "4";
})(Steps = exports.Steps || (exports.Steps = {}));
exports.carrierCancel = {
    label: 'Carrier cancelled policy',
    value: 'Carrier cancelled policy',
    subtitle: 'The carrier cancelled the policy prior to expiration date.',
};
exports.customerCancel = {
    label: 'Customer requested to cancel policy',
    value: 'Customer requested to cancel policy',
    subtitle: 'The customer requested to cancel the policy prior to expiration date.',
};
exports.customerNonrenew = {
    label: 'Policy not renewing due to customer request',
    value: 'Policy not renewing due to customer request',
    subtitle: 'The customer requested not to renew the policy.',
};
exports.newfrontNonrenew = {
    label: 'Policy not renewing due to Newfront decision',
    value: 'Policy not renewing due to Newfront decision',
    subtitle: 'Newfront chose to off-risk customer.',
};
exports.lostToBor = {
    label: 'Policy lost to BOR',
    value: 'Policy lost to BOR',
    subtitle: 'The customer BOR transferred away from Newfront.',
};
exports.NO_LONGER_NEED_INSURANCE_POLICY_LOSS_REASONS = [
    'No longer need insurance - Business shut down',
    'No longer need insurance - Insured entity no longer requires coverage (sold property, discontinued product, etc.)',
    'No longer need insurance - Non-recurring coverage',
];
exports.CLIENT_PREFERENCE_POLICY_LOSS_REASONS = [
    'Client preference - Required faster turnaround times',
    'Client preference - Required more certs support',
    'Client preference - Required more claims/risk management support',
    'Client preference - Required specialized expertise',
    'Client preference - Issues with interpersonal relationship (AM or Producer)',
    'Client preference - Insurance buyer at company changed (e.g. via acquisition, leadership change)',
    'Client preference - Client requested non-renew/cancel without context',
    'Client preference - AM or servicing contact reassigned',
];
exports.CUSTOMER_UNRESPONSIVE_POLICY_LOSS_REASONS = [
    'Customer unresponsive',
];
exports.endPolicyOptions = [exports.customerCancel, exports.customerNonrenew, exports.newfrontNonrenew, exports.lostToBor, exports.carrierCancel];
exports.PRODUCER_LEFT_NEWFRONT_POLICY_LOSS_REASONS = [
    'Producer left Newfront',
];
exports.CANCEL_REWRITE_POLICY_LOSS_REASONS = ['Cancel/Rewrite'];
exports.CONSOLIDATED_TO_PACKAGE_POLICY_LOSS_REASONS = [
    'Consolidated to package',
];
exports.NF_UNABLE_TO_PLACE_RENEWAL_POLICY_LOSS_REASONS = [
    'NF unable to place coverage - Blocked',
    'NF unable to place coverage - Lost on pricing',
    'NF unable to place coverage - Did not have market appointment / access',
    'NF unable to place coverage - Customer not a good fit for Newfront',
    'NF unable to place coverage - Quoting process delayed',
    'NF unable to place coverage - Client wanted to approach more markets',
];
exports.CUSTOMER_COMPLIANCE_POLICY_LOSS_REASONS = [
    'Customer Compliance - Non-payment',
    'Customer Compliance - Misrepresented client exposures',
    'Customer Compliance - Client did not meet carrier requirements (e.g. inspection, audit, binding subjectivities)',
];
exports.CLIENT_NONPAY_POLICY_LOSS_REASONS = ['Client cancelled twice for non-pay'];
